<script>
  export let rows = [];
  export let caption = '';
  export let showActions = false;
  $: columns = [...new Set(rows.flatMap(row => Object.keys(row)))];
  function text(value) { return value != null && typeof value === 'object' ? JSON.stringify(value) : String(value ?? ''); }
</script>
{#if rows.length}<div class="table-scroll"><table><caption>{caption}</caption><thead><tr>{#if showActions}<th scope="col">Comprobante</th>{/if}{#each columns as key}<th scope="col">{key}</th>{/each}</tr></thead><tbody>{#each rows as row}<tr>{#if showActions}<td class="document-action"><slot name="actions" {row} /></td>{/if}{#each columns as key}<td>{text(row[key])}</td>{/each}</tr>{/each}</tbody></table></div>{:else}<p class="muted">Sin registros.</p>{/if}
